// Wrap bare strings in the field shape expected by the bulk-translate service.
export const formatTranslationItems = (items, fieldKey) => {
  const concepts = Object.fromEntries(
    Object.entries(items.concepts || {}).map(([id, value]) => [id, { [fieldKey]: value }])
  );
  const questions = Object.fromEntries(
    Object.entries(items.questions || {}).map(([id, entry]) => [
      id,
      {
        ...(entry.text !== undefined ? { [fieldKey]: entry.text } : {}),
        ...(entry.options
          ? {
              options: Object.fromEntries(
                Object.entries(entry.options).map(([optionId, value]) => [
                  optionId,
                  { [fieldKey]: value },
                ])
              ),
            }
          : {}),
        ...(entry.properties
          ? {
              properties: Object.fromEntries(
                Object.entries(entry.properties).map(([propertyKey, value]) => [
                  propertyKey,
                  { [fieldKey]: value },
                ])
              ),
            }
          : {}),
        // Grid rows use the backend `sub_questions` key.
        ...(entry.subQuestions
          ? {
              sub_questions: Object.fromEntries(
                Object.entries(entry.subQuestions).map(([subQuestionId, value]) => [
                  subQuestionId,
                  { [fieldKey]: value },
                ])
              ),
            }
          : {}),
      },
    ])
  );
  return { concepts, questions };
};

// Unwrap translated text, tolerating text/rich_text swaps and list responses.
const transformTranslationText = (wrapped, fieldKey) => {
  const value = wrapped?.[fieldKey] ?? wrapped?.rich_text ?? wrapped?.text ?? '';
  return Array.isArray(value) ? value.join(fieldKey === 'rich_text' ? '' : ' ') : value;
};

export const transformTranslatedItems = (items, fieldKey) => {
  const concepts = Object.fromEntries(
    Object.entries(items.concepts || {}).map(([id, wrapped]) => [
      id,
      transformTranslationText(wrapped, fieldKey),
    ])
  );
  const questions = Object.fromEntries(
    Object.entries(items.questions || {}).map(([id, entry]) => [
      id,
      {
        ...(entry?.text !== undefined || entry?.rich_text !== undefined
          ? { text: transformTranslationText(entry, fieldKey) }
          : {}),
        ...(entry?.options
          ? {
              options: Object.fromEntries(
                Object.entries(entry.options).map(([optionId, wrapped]) => [
                  optionId,
                  transformTranslationText(wrapped, fieldKey),
                ])
              ),
            }
          : {}),
        ...(entry?.properties
          ? {
              properties: Object.fromEntries(
                Object.entries(entry.properties).map(([propertyKey, wrapped]) => [
                  propertyKey,
                  transformTranslationText(wrapped, fieldKey),
                ])
              ),
            }
          : {}),
        // Convert backend `sub_questions` back to caller-facing `subQuestions`.
        ...(entry?.sub_questions
          ? {
              subQuestions: Object.fromEntries(
                Object.entries(entry.sub_questions).map(([subQuestionId, wrapped]) => [
                  subQuestionId,
                  transformTranslationText(wrapped, fieldKey),
                ])
              ),
            }
          : {}),
      },
    ])
  );
  return { concepts, questions };
};

export const transformTranslationLanguages = (payload) => {
  if (!Array.isArray(payload)) return [];

  return payload
    .map((language) => {
      const value = language?.code;
      if (!value) return null;
      return {
        label: language?.name || value,
        value,
      };
    })
    .filter(Boolean);
};
